import { render, staticRenderFns } from "./ResetVerify.vue?vue&type=template&id=253e4b9c&scoped=true"
import script from "./ResetVerify.vue?vue&type=script&lang=js"
export * from "./ResetVerify.vue?vue&type=script&lang=js"
import style0 from "./ResetVerify.vue?vue&type=style&index=0&id=253e4b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e4b9c",
  null
  
)

export default component.exports